/* src/app/feature-modules/lessons/components/update-lesson/update-lesson.component.css */
.square.wrapper {
  width: 100%;
  height: 200px;
}
.square.overlay,
.image-wrapper {
  border-radius: 5px !important;
}
.square i {
  margin-top: 82px !important;
}
.image-upload-container {
  width: 100%;
  margin-bottom: 20px;
}
.image-preview-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 16px;
  margin-bottom: 16px;
}
.image-preview-item {
  position: relative;
  aspect-ratio: 1;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.preview-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.image-upload-box {
  aspect-ratio: 1;
  border: 2px dashed #ccc;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: border-color 0.2s;
}
.image-upload-box:hover {
  border-color: #666;
}
.image-upload-box mat-icon {
  font-size: 32px;
  width: 32px;
  height: 32px;
  margin-bottom: 8px;
  color: #666;
  overflow: visible !important;
}
.image-upload-box span {
  color: #666;
  font-size: 14px;
}
.image-actions {
  position: absolute;
  top: 8px;
  right: 8px;
  display: flex;
  gap: 8px;
  z-index: 2;
}
.action-btn {
  background: rgba(255, 255, 255, 0.9);
  border: none;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.2s;
}
.action-btn:hover {
  background: rgb(255, 255, 255);
}
.preview-btn {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(255, 255, 255, 0.9);
  border: none;
  border-radius: 0%;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
  opacity: 0;
  z-index: 2;
}
.image-preview-item:hover .preview-btn {
  opacity: 0;
}
.preview-btn:hover {
  background: rgba(255, 255, 255, 1);
  transform: translate(-50%, -50%) scale(1.1);
}
.preview-btn mat-icon {
  font-size: 24px;
  width: 24px;
  height: 24px;
  color: #333;
}
.delete-btn {
  position: absolute;
  top: 0px;
  right: 0px;
  background: rgba(255, 0, 0, 0.8);
  border: none;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.2s;
}
.delete-btn .mat-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}
.delete-btn:hover {
  background: rgb(255, 0, 0);
}
.image-preview-item::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  opacity: 0;
  transition: opacity 0.2s;
}
.image-preview-item:hover::after {
  opacity: 1;
}
.image-preview-dialog {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}
.preview-container {
  position: relative;
  max-width: 90%;
  max-height: 90%;
}
.preview-full-image {
  max-width: 100%;
  max-height: 90vh;
  object-fit: contain;
}
.close-btn {
  position: absolute;
  top: -40px;
  right: 0;
  background: rgba(255, 255, 255, 0.9);
  border: none;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.2s;
}
.close-btn:hover {
  background: rgba(255, 255, 255, 1);
}
.ck-editor-wrapper {
  border: 1px solid #c4c4c4;
  border-radius: 4px;
  overflow: hidden;
}
.ck-editor-wrapper--invalid {
  border-color: #f44336;
  box-shadow: 0 0 0 1px #f44336 inset;
}
::ng-deep .lesson-dropdown-error,
::ng-deep .lesson-dropdown-error .mat-option-text,
::ng-deep .lesson-dropdown-error .mdc-list-item__primary-text {
  color: #f44336 !important;
}
:host ::ng-deep .lesson-required-field--invalid .mat-mdc-form-field-outline,
:host ::ng-deep .lesson-required-field--invalid .mdc-notched-outline__leading,
:host ::ng-deep .lesson-required-field--invalid .mdc-notched-outline__notch,
:host ::ng-deep .lesson-required-field--invalid .mdc-notched-outline__trailing {
  border-color: #f44336 !important;
}
:host ::ng-deep .lesson-required-field--invalid .mat-mdc-floating-label,
:host ::ng-deep .lesson-required-field--invalid .mat-mdc-select-arrow {
  color: #f44336 !important;
}
.lesson-validation-flash .ck-editor-wrapper--invalid,
:host ::ng-deep .lesson-validation-flash .lesson-required-field--invalid .mdc-notched-outline,
:host ::ng-deep .lesson-validation-flash .mat-mdc-form-field.mat-form-field-invalid .mdc-notched-outline {
  animation: lesson-required-flash 650ms ease-in-out;
}
@keyframes lesson-required-flash {
  0%, 100% {
    filter: none;
  }
  50% {
    filter: drop-shadow(0 0 4px rgba(244, 67, 54, 0.65));
  }
}
.ck-editor-wrapper:has(ckeditor.ng-invalid.ng-touched) {
  border-color: #f44336;
}
.ck-editor-error {
  color: #f44336;
  margin-top: 4px;
  display: block;
}
:host ::ng-deep .ck-editor-wrapper .ck-toolbar {
  border: none !important;
  border-bottom: 1px solid #c4c4c4 !important;
  border-radius: 0 !important;
  background: #fafafa;
}
:host ::ng-deep .ck-editor-wrapper .ck-content {
  border: none !important;
  border-radius: 0 !important;
  min-height: 150px;
  padding: 12px 16px;
  box-shadow: none !important;
}
/*# sourceMappingURL=update-lesson.component.css.map */
